import React from 'react';

import { Link } from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

const IOSLink = ({ name, period = {}, onClick }) => {
  const isPeriod = period.from && period.to;

  return (
    <Link underline={'none'} onClick={onClick}>
      {name}
      {isPeriod ? ' / ' : null}
      {isPeriod ? (
        <DateRangeFormatter
          value={[period.from, period.to]}
          template={'MMM yyyy'}
          timeZone={'utc'}
          padding={0}
        />
      ) : null}
    </Link>
  );
};
export default IOSLink;
